<div class="col-12">
  <div class="col-12">
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <!-- ファイルエクスポートボタン -->
    <b-button class="ml-2 mt-2" v-if="!WS138.enabled && !WS148.enabled" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
    <!-- ダウンロードボタン(WS.138、WS.148) -->
    <b-button class="ml-2 mt-2" v-else-if="isSBRUser || WS148.enabled" variant="primary" size="sm" @click="downloadFile"
      :disabled="(WS138.enabled && !WS138.fileExists) || (WS148.enabled && !WS148.fileExists)">
      {{ $t('message.button_vehicle_system_download_zip') }}
    </b-button>
    <template v-if="isWs45">
      <!-- モニタテスト確認ボタン(WS.45) -->
      <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="openDetailMonitorTestModal">
        {{ $t('individual.button_monitor_test_confirm') }}
      </b-button>
      <!-- DTC確認ボタン(WS.45) -->
      <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="openDetailDtcModal">
        {{ $t('individual.button_dtc_confirm') }}
      </b-button>
    </template>
    <div v-if="isWs45" class="float-right mt-2">
      <!-- グラフ設定ボタン(WS.45) -->
      <no-text-svg-button :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.CONFIG"
        @click="handleConfigureGraph" :disabled="isGraphConfigButtonDisable"
        :title="$t('individual.button_data_monitor_graph_config')" />
      <!-- リセットズームボタン(WS.45) -->
      <no-text-svg-button :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.RESET_ZOOM"
        @click="handleResetZoom($event)" :disabled="isResetZoomButtonDisable"
        :title="$t('individual.label_data_monitor_reset_zoom')" />
    </div>
  </div>
  <!-- ログデータ表示(WS.138) -->
  <div v-if="WS138.enabled" class="col-12 work-support-message mb-4">
    <div class="mt-4 mb-2 ml-2">{{ WS138.title }}</div>
    <div v-for="(item, index) in WS138.logDataList" :key="index" class="log-data-container mt-1">
      <div class="ml-2 mr-2">{{ item.results }}</div>
    </div>
  </div>
  <!-- テレマティクスログ表示(WS.148) -->
  <div v-else-if="WS148.enabled" class="col-12 work-support-message mb-4">
    <div class="mt-4 mb-2 ml-2">{{ WS148.title }}</div>
    <div v-for="(item, index) in WS148.logDataList" :key="index" class="log-data-container mt-1">
      <div class="ml-2 mr-2">{{ item.results }}</div>
    </div>
  </div>
  <!-- WS.172データ表示テーブル -->
  <div v-else-if="isWs172" class="col-12">
    <custom-table :key="'ws172-' + ws172TableRenderKey" class="mt-2 ml-2" type="simple" useSort useStripeStyle hasTabs currentSortkey="no"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns">
    </custom-table>
  </div>
  <!-- データ表示テーブル -->
  <div v-else-if="!isWs45" class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="status"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns" @rowButtonClicked="openDetailFDModal">
      <template v-slot:rowButton>{{ $t(`individual.button_fd`) }}</template>
    </custom-table>
  </div>
  <!-- データモニタ表示 -->
  <div class="data-monitor-page">
    <div v-if="dataMonitor?.dataMonitorShow || false" class="dm-area-rc">
      <data-monitor-measure class="data-monitor" ref="data_monitor_measure" :inExecution="inExecution"
        :inPlaying="inPlaying" :conversionList="dataMonitor.conversionList"
        :dataMonitorList="dataMonitor.dataMonitorList" :selectedFunctionList="dataMonitor.selectedFuncs"
        :selectedFunctionHash="dataMonitor.selectedFunctionHash" :graphConfigInfo="dataMonitor.graphConfigInfo"
        :completeResolve="dataMonitor.completeResolve" :baseOrgTime="dataMonitor.baseTime" :measurementUuid="measuresId"
        :apiToken="dataMonitor.apiToken" :endpoint="dataMonitor.endpoint" :highlightItems="dataMonitor.highlightItems"
        :funcValues="dataMonitor.funcValues" :specifiedSystemId="system"
        :dataMonitorFunctionSettings="dataMonitor.dataMonitorFunctionSettings" :savedMarkerInfo="savedMarkerInfo"
        :isCompleted="isCompleted" :ws45MarkerInfo="ws45MarkerInfo" :isTestMode="false"
        @change-selected-funcs="changeSelectedFuncs"
        @set-graph-config="setGraphConfig" @change-check-value="changeCheckValue"
        @current-tab-changed="currentTabChanged" @zoom-pan-state-changed="zoomPanStateChanged"
        @back-select="backSelect" />
    </div>
  </div>

  <!-- モニタテスト結果表示画面 -->
  <b-modal v-model="isMonitorTest" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- header -->
    <template v-slot:header>
      <div class="text-center w-100">{{ $t('message.common_title_infomation') }}</div>
    </template>
    <!-- body -->
    <template v-slot:default>
      <detail-monitor-test-modal ref="detail_monitor_test_modal" />
    </template>
    <!-- footer -->
    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="closeMonitorTestModal" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- DTC確認画面 -->
  <b-modal v-model="isDetailDtc" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- header -->
    <template v-slot:header>
      <div class="text-center w-100">{{ $t('message.common_title_infomation') }}</div>
    </template>
    <!-- body -->
    <template v-slot:default>
      <detail-dtc-modal :systemId="system" :dataPlayback="dtcModalDataPlayback" :projectId="projectId"
        :linkedIds="linkedIds" :operationScreen="operationScreen" :dataName="measuredDataName" ref="detail_dtc_modal"
        @dtcModalPhaseChange="dtcModalPhaseChange" />
    </template>
    <!-- footer -->
    <template v-slot:footer>
      <div class="text-center w-100">
        <template v-if="dtcModalPhase === 'dtcDisplay'">
          <b-button size="sm" variant="primary" @click="closeDtcModal" class="mx-2">
            {{ $t("message.common_button_ok") }}
          </b-button>
        </template>
        <template v-if="dtcModalPhase !== 'dtcDisplay'">
          <b-button size="sm" variant="primary" @click="dtcModalProcess" class="mx-2">
            {{ $t('message.common_button_ok') }}
          </b-button>
        </template>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>